/** 이용권 코드 본문 문자셋: I,O,0,1 제외(L 포함). 32종 */
export const PASS_CODE_BODY_CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

/**
 * 신규 발급 본문 길이.
 * 32^12 ≈ 1.15×10^18 (약 60비트) — 추측 등록을 현실적으로 어렵게 하면서 입력 부담을 유지.
 * (기존 8자=40비트는 대량 시도에 취약)
 */
export const PASS_CODE_BODY_LENGTH = 12;

/** 하위 호환: 예전에 발급된 8자 코드도 등록 허용, 상한 16 */
export const PASS_CODE_BODY_MIN_LENGTH = 8;
export const PASS_CODE_BODY_MAX_LENGTH = 16;

const COUPON_BODY_RE = new RegExp(
  `^[A-HJ-NP-Z2-9]{${PASS_CODE_BODY_MIN_LENGTH},${PASS_CODE_BODY_MAX_LENGTH}}$`,
);

function randomBody(length: number = PASS_CODE_BODY_LENGTH): string {
  const chars = PASS_CODE_BODY_CHARS;
  const out: string[] = [];
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    const buf = new Uint32Array(length);
    crypto.getRandomValues(buf);
    for (let i = 0; i < length; i += 1) {
      out.push(chars[buf[i]! % chars.length]!);
    }
    return out.join('');
  }
  for (let i = 0; i < length; i += 1) {
    out.push(chars[Math.floor(Math.random() * chars.length)]!);
  }
  return out.join('');
}

/**
 * 사용자 입력(공백·하이픈 허용)을 `GRP-…` 형태로 정규화.
 * 형식이 맞지 않으면 null.
 */
export function parseGroupCouponCodeInput(raw: string): string | null {
  const compact = raw.trim().toUpperCase().replace(/[\s-]/g, '');
  if (!compact.startsWith('GRP')) return null;
  const suffix = compact.slice(3);
  if (!COUPON_BODY_RE.test(suffix)) return null;
  return `GRP-${suffix}`;
}

/**
 * 이벤트 이용권 코드 입력을 `EVT-…` 형태로 정규화(본문 문자셋은 그룹 쿠폰과 동일).
 */
export function parseEventCouponCodeInput(raw: string): string | null {
  const compact = raw.trim().toUpperCase().replace(/[\s-]/g, '');
  if (!compact.startsWith('EVT')) return null;
  const suffix = compact.slice(3);
  if (!COUPON_BODY_RE.test(suffix)) return null;
  return `EVT-${suffix}`;
}

/** 그룹 이용권 쿠폰 코드 */
export function generateGroupCouponCode(): string {
  return `GRP-${randomBody()}`;
}

/** 이벤트 이용권 코드 */
export function generateEventCouponCode(): string {
  return `EVT-${randomBody()}`;
}

/**
 * 베타 테스터 이용권 코드 입력을 `CBT-…` 형태로 정규화.
 */
export function parseBetaTesterCouponCodeInput(raw: string): string | null {
  const compact = raw.trim().toUpperCase().replace(/[\s-]/g, '');
  if (!compact.startsWith('CBT')) return null;
  const suffix = compact.slice(3);
  if (!COUPON_BODY_RE.test(suffix)) return null;
  return `CBT-${suffix}`;
}

/** 베타 테스터 이용권 코드 */
export function generateBetaTesterCouponCode(): string {
  return `CBT-${randomBody()}`;
}

export function isBetaTesterPassCode(code: string): boolean {
  return code.trim().toUpperCase().startsWith('CBT-');
}

export function isEventPassCode(code: string): boolean {
  return code.trim().toUpperCase().startsWith('EVT-');
}

/** 같은 일자 기준으로 달만 더한 현지 자정 */
export function addCalendarMonthsStartOfDay(d: Date, months: number): Date {
  return new Date(d.getFullYear(), d.getMonth() + months, d.getDate(), 0, 0, 0, 0);
}

export function addDaysStartOfDay(d: Date, days: number): Date {
  const x = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
  x.setDate(x.getDate() + days);
  return x;
}
